<template>
    <div>
        <div class="user-input-box">
            <div class="input-tit">私人信息</div>
            <div class="user-input-line">
                <div class="option-name">注册时间：</div>
                <div class="option-box">
                    <img class="date" :src="GLOBAL.Images.icon_calendar" alt="">
                    <span>{{userInfo.register_time_text}}</span>
                </div>
            </div>
            <div class="user-input-line">
                <div class="option-name">学校名称<span class="red">*</span>：</div>
                <div class="option-box">
                    <el-input size="small" v-model="school" placeholder="请输入"></el-input>
                </div>
            </div>
            <div class="user-input-line">
                <div class="option-name">年级<span class="red">*</span>：</div>
                <div class="option-box">
                    <el-input size="small" v-model="gradeVal" placeholder="请输入"></el-input>
                </div>
            </div>
            <div class="user-input-line">
                <div class="option-name">班级<span class="red">*</span>：</div>
                <div class="option-box">
                    <el-input size="small" v-model="schoolClass" placeholder="请输入"></el-input>
                </div>
            </div>
            <div class="user-input-line">
                <div class="option-name">真实姓名<span class="red">*</span>：</div>
                <div class="option-box">
                    <el-input size="small" v-model="realname" placeholder="请输入"></el-input>
                </div>
            </div>
            <div class="user-input-line">
                <div class="option-name">性别：</div>
                <div class="option-box">
                    <el-select size="small" v-model="sexVal" placeholder="请选择">
                        <el-option v-for="item in sex" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="user-input-line">
                <div class="option-name">年龄：</div>
                <div class="option-box">
                    <el-input size="small" v-model="age" placeholder="请输入"></el-input>
                </div>
            </div>
            <div class="user-input-line">
                <div class="option-name">地址：</div>
                <div class="option-box">
                    <el-input size="small" autosize v-model="site" placeholder="请输入"></el-input>
                </div>
            </div>
        </div>
        <div class="user-input-box">
            <div class="input-tit">联系方式</div>

            <div class="user-input-line">
                <div class="option-name">邮箱地址<span class="red">*</span>：</div>
                <div class="option-box">
                    <el-input size="small" v-model="email" placeholder="请输入"></el-input>
                </div>
            </div>
            <div class="user-input-line">
                <div class="option-name">QQ号码：</div>
                <div class="option-box">
                    <el-input size="small" v-model="qqNum" placeholder="请输入"></el-input>
                </div>
            </div>
            <div class="user-input-line">
                <div class="option-name">微信号：</div>
                <div class="option-box">
                    <el-input size="small" v-model="wxNum" placeholder="请输入"></el-input>
                </div>
            </div>
            <div class="user-input-line">
                <div class="option-name">电话号码<span class="red">*</span>：</div>
                <div class="option-box">
                    <el-input size="small" v-model="mobile" placeholder="请输入"></el-input>
                </div>
            </div>
        </div>
        <div class="save-btn">
            <el-button type="primary" @click="saveUserInfo">保存</el-button>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapState, mapMutations, mapActions} from "vuex";
    import Lockr from 'lockr'
    import {userInfo, saveUserInfo} from "@/api/user";

    export default {
        name: "userInfo",
        computed: {
            ...mapGetters(['userInfo'])
        },
        data() {
            return {
                registerTime: '', //注册时间
                school: '', //学校
                //年级
                gradeVal: '', //年级
                schoolClass: '', //班级
                sex: [{
                    value: '1',
                    label: '男'
                }, {
                    value: '2',
                    label: '女'
                }],
                sexVal: '', //性别
                age: '', //年龄
                realname: '', //真实姓名
                site: '', //地区
                email: '', //邮箱
                qqNum: '', //qq号
                wxNum: '', //微信号
                mobile: '', //电话号
            };
        },
        methods: {
            //获取个人信息
            getUserInfo() {
                let data = {
                    token: Lockr.get('token'),
                }
                userInfo(data).then((res) => {
                    this.school = res.data.school
                    this.registerTime = res.data.register_time_text
                    this.gradeVal = res.data.grade
                    this.schoolClass = res.data.class
                    this.realname = res.data.realname
                    if (res.data.sex == 1) {
                        this.sexVal = '男'
                    } else {
                        this.sexVal = '女'
                    }
                    this.age = res.data.age
                    this.site = res.data.address
                    this.email = res.data.email
                    this.qqNum = res.data.qq
                    this.wxNum = res.data.wx_code
                    this.mobile = res.data.mobile
                })
            },
            // 保存信息
            saveUserInfo() {
                let data = {
                    token: Lockr.get('token'),
                    school: this.school,
                    grade: this.gradeVal,
                    class: this.schoolClass,
                    realname: this.realname,
                    address: this.site,
                    sex: this.sexVal,
                    age: this.age,
                    email: this.email,
                    qq: this.qqNum,
                    wx_code: this.wxNum,
                    mobile: this.mobile,
                }
                if (data.school == '') {
                    this.$message('请填写学校名称')
                    return
                }
                if (data.grade == '') {
                    this.$message('请填写年级')
                    return
                }
                if (data.class == '') {
                    this.$message('请填写班级')
                    return
                }
                if (data.realname == '') {
                    this.$message('请填写真实姓名')
                    return
                }
                if (data.email == '') {
                    this.$message('请填写邮箱地址')
                    return
                }
                if (data.mobile == '') {
                    this.$message('请填写电话号码')
                    return
                }
                saveUserInfo(data).then((res) => {
                    if (res.code == 1) {
                        this.$message({
                            message: res.msg,
                            type: 'success',
                            duration: '2000',
                            onClose() {
                            }
                        });
                    } else {
                        this.$message({
                            message: res.msg,
                            duration: '2000',
                        });
                    }
                })
            },
            handleChange(value) {
                console.log(value)
                console.log(this.selectedOptions)
            },
        },
        created() {
            this.getUserInfo()
        }
    }
</script>

<style scoped lang='less'>
    .user-input-box {
        width: 100%;
        border: 1px solid rgba(217, 217, 217, 1);
        padding: 30px 0;
        margin-bottom: 20px;

        .red {
            color: #ff3366;
        }

        .input-tit {
            text-align: center;
            font-size: 18px;
            font-weight: 600;
        }

        .user-input-line {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            margin: 13px 0;

            .option-name {
                width: 150px;
                text-align: right;
            }

            .option-box {
                display: flex;
                align-items: center;
                height: 40px;
                width: 190px;

                .date {
                    width: 20px;
                    height: 20px;
                    margin-right: 10px;
                }
            }
        }
    }

    .save-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0;

        .el-button {
            background-color: #00BFCC;
            border-color: #00BFCC;
            width: 160px;
        }
    }
</style>